<div class="container-fluid">
  @if (step === 1) {
    <div class="row justify-content-center mt-5 mb-5">
      <div class="col-md-10 col-lg-6">
        <h3 class="font-weight-extrabold text-center text-black">
          {{
            (receiptType == ReceiptType.Investment
              ? 'investment.choosePayment'
              : 'mysec.chooseTopUp'
            ) | translate
          }}:
        </h3>
      </div>
    </div>
    @if (!isLoadingInvestmentInfo) {
      <app-payment-process
        [isLoading]="isLoading"
        [isPSTX]="isPSTX"
        [isDuitNowEnabled]="isDuitNowEnabled"
        [wallet]="walletData"
        [difference]="difference"
        [receiptType]="receiptType"
        [campaign]="campaign"
        [investment]="investment"
        [document]="document"
        [paymentAmount]="amount"
        [referenceNo]="refNo"
        [lotAmount]="investment?.lotQuantity"
        [continueLink]="continueLink"
        [documents]="documents"
        [maxFiles]="maxFiles"
        [attachmentInfoList]="attachmentInfoList"
        (choosePayment)="setPayment($event)"
        (nextStep)="nextStep($event)"
        (uploadReceipt)="uploadReceipt($event)"
        (uploadSuccess)="onUploadSuccess($event)"
        (uploadFailed)="onUploadFailed($event)"
      ></app-payment-process>
    }
  }

  @if (step === 2) {
    @if (selectedPaymentType === PaymentType.MaybankFPX) {
      <app-fpx-payment [paymentAmount]="amount" (choosePayment)="setPayment($event)">
      </app-fpx-payment>
    }
    @if (selectedPaymentType === PaymentType.DuitNow) {
      <app-duitnow-payment [paymentAmount]="amount" (choosePayment)="setPayment($event)">
      </app-duitnow-payment>
    }
  }

  @if (isLoadingInvestmentInfo) {
    <agmo-loading></agmo-loading>
  }
</div>
